import React from "react";
import ControlBar from "./controls/ControlBar";
import { ControlBarProvider } from "./controls/ControlBarContext";
import Parks from "./Parks/Parks";

function Home() {
  return (
    <div className="container mt-4 mx-auto px-4 md:px-12">
      <ControlBarProvider>
        <ControlBar />
        <Parks />
      </ControlBarProvider>
    </div>
  );
}

export default Home;
